<template>
  <b-nav
    vertical
    class="scrollspy"
    slot="header"
    v-b-scrollspy="{
      element: 'body',
      offset: 90,
      method: 'auto',
      throttle: 100,
    }">
    <b-nav-item href="#ueberblick" @click="scrollToHref">{{ $t('navigation.overview') }}</b-nav-item>
    <b-nav-item href="#angebot" @click="scrollToHref">{{ offerLabel }}</b-nav-item>
    <b-nav-item href="#schulungsinhalte" @click="scrollToHref">{{ $t('navigation.seminarContent') }}</b-nav-item>
    <b-nav-item v-if="hasTrainerSection" href="#dozent" @click="scrollToHref">{{ $t('navigation.trainer') }}</b-nav-item>
    <b-nav-item href="#gfucyrusag" @click="scrollToHref">{{ $t('navigation.gfu') }}</b-nav-item>
    <b-nav-item href="#durchfuehrungsarten" @click="scrollToHref">{{ $t('navigation.executionTypes') }}</b-nav-item>
    <b-nav-item href="#services" @click="scrollToHref">{{ $t('navigation.services') }}</b-nav-item>
  </b-nav>
</template>

<script>

import { mapGetters } from "vuex";

export default {
  name: 'ScrollSpy',

  methods: {
    scrollToHref(e) {
      e.preventDefault();
      const href = e.target.getAttribute('href')
      const el = href ? document.querySelector(href) : null
      if (el) {
        this.scrollToElement(el);
        window.history.pushState(null, null, href);
      }
    },
    scrollToElement(el) {
      if (!el) return;
      window.scrollTo({
        behavior: 'smooth',
        top: el.getBoundingClientRect().top - document.body.getBoundingClientRect().top - 90,
      })
    }
  },
  computed: {
    ...mapGetters(["offer", "trainer", "offerSections"]),
    hasTrainerSection() {
      return Boolean(this.trainer);
    },
    offerLabel() {
      const exceptions = ['4575499581', '4c4cf70917', 'cac3b1174c', 'e0afd6560e'];
      if (this.offer && exceptions.indexOf(this.offer.hash) !== -1) {
        return this.$t('navigation.priceIndication');
      }
      return this.$t('navigation.offer');
    }
  },
  mounted() {
    const el = location.hash ? document.querySelector(location.hash) : null
    if (el) {
      this.scrollToElement(el);
    }
  },
}

</script>

<style>
.scrollspy {
  background-color: rgb(4, 43, 96);

  position: fixed;
  top: 50%;
  left: 0.7rem;
  border-radius: 2px;
  margin: 0;
  padding: 0.5rem 0;
  z-index: 1;
  transform: translateY(-50%);
}

.scrollspy .nav-link {
  color: rgba(255, 255, 255, 0.6);
  padding: 0.25rem 0.9rem 0.25rem 0.7rem;
  transition: color 0.1s linear, border 0.1s linear;
  border-left: 5px solid transparent;
  text-decoration: none;
}

.scrollspy .nav-link:hover {
  color: rgba(255, 255, 255, 0.8);
}

.scrollspy .nav-link.active {
  color: #fff;
  border-color: #fdc41f;
  font-weight: bold;
}

@media (max-width: 1500px) {
  .scrollspy {
    display: none;
  }
}
</style>
